import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import OfferAssetChassisNumberPopupComponent from './OfferAssetChassisNumberPopupComponent';

const OfferAssetChassisNumberPopupContainer = ({
  onPropertyChange,
  chassisNumberError,
  chassisNumber,
  handleChassisNumberSave,
  updating,
  handleCancelChassisNumberSave,
  localChassisNumber
}) => {
  const [open, setOpen] = useState(false);
  const [initialChassisNumber, setInitialChassisNumber] = useState(chassisNumber);

  useEffect(() => {
    if (updating === false) {
      setOpen(false);
      setInitialChassisNumber(chassisNumber);
    }
    // eslint-disable-next-line
  }, [updating]);

  const handleChange = value => {
    onPropertyChange('chassisNumber', value, true);
  };

  return (
    <OfferAssetChassisNumberPopupComponent
      onPropertyChange={onPropertyChange}
      chassisNumberError={chassisNumberError}
      chassisNumber={chassisNumber}
      handleChassisNumberSave={handleChassisNumberSave}
      updating={updating}
      handleCancelChassisNumberSave={handleCancelChassisNumberSave}
      initialChassisNumber={initialChassisNumber}
      open={open}
      localChassisNumber={localChassisNumber}
      handleChange={handleChange}
      setOpen={setOpen}
    />
  );
};

OfferAssetChassisNumberPopupContainer.propTypes = {
  onPropertyChange: PropTypes.func.isRequired,
  handleChassisNumberSave: PropTypes.func.isRequired,
  handleCancelChassisNumberSave: PropTypes.func.isRequired,
  updating: PropTypes.bool.isRequired,
  chassisNumber: PropTypes.string,
  chassisNumberError: PropTypes.string,
  localChassisNumber: PropTypes.string
};

export default OfferAssetChassisNumberPopupContainer;
